﻿angular.module('fliptoWeb')
    .directive("ftSquashingMenu", [function() {

        class SquashingMenuController {

            public menus: Array<string> = [];
            public activeMenu: string;

            addMenu(name: string) {
                this.menus.push(name);
            }

            setActive(name: string) {
                this.activeMenu = name;
            }

            swipeLeft() {
                let idx = this.menus.indexOf(this.activeMenu);
                if (idx == -1) return;
                let newIdx = idx == 0 ? this.menus.length - 1 : idx - 1;
                this.setActive(this.menus[newIdx]);
            }

            swipeRight() {
                let idx = this.menus.indexOf(this.activeMenu);
                if (idx == -1) return;
                let newIdx = idx == this.menus.length - 1 ? 0 : idx + 1;
                this.setActive(this.menus[newIdx]);
            }
        }

        return {
            scope: {},
            require: "ftSquashingMenu",
            controller: () => new SquashingMenuController(),
            controllerAs: "vm",
            bindToController: true

        };

    }])
    .directive("ftSquashingMenuItem", [function() {

        return {
            require: "^ftSquashingMenu",
            link: function(scope, elem, attrs, ctrl) {
                let menuName = attrs.ftSquashingMenuItem;
                ctrl.addMenu(menuName);

                if (angular.isDefined(attrs.active)) ctrl.setActive(menuName);

                elem.on("click", () => { scope.$apply(() => ctrl.setActive(menuName)); });
                scope.$watch(() => ctrl.activeMenu, activeMenu => {
                    if (activeMenu === menuName) {
                        elem.addClass("active");
                    } else {
                        elem.removeClass("active");
                    }
                }, true);
                scope.$on("$destroy", () => elem.off("click"));
            }
        };
    }])
    .directive("ftSquashingMenuContent", [function() {

        return {
            require: "^ftSquashingMenu",
            link: function(scope, elem, attrs, ctrl) {
                let menuName = attrs.ftSquashingMenuContent;

                scope.$watch(() => ctrl.activeMenu, () => {
                    if (menuName === ctrl.activeMenu) elem.addClass("active");
                    else elem.removeClass("active");
                }, true);

                if (angular.isDefined(attrs.supportSwipe)) {
                    var hammertime = new window["Hammer"](elem[0]);
                    hammertime.on('swipeleft', function () {
                        scope.$apply(() => { ctrl.swipeLeft(); });
                    });
                    hammertime.on('swiperight', function () {
                        scope.$apply(() => { ctrl.swipeRight(); });
                    });
                }

            }
        };
    }]);
